import calls from '@/backend/api-calls'

const state = () => ({
  deliveries: [],
  selected: [],
  allSelected: false,
  loading: false,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {}
})

// getters
const getters = {
  ids: state => {
    return state.deliveries.map(d => d.id);
  }
}

// actions
const actions = {
  getDeliveries: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.deliveries.get(parameters)
        .then(resp => {
          commit("setDeliveries", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  addDelivery({commit}, data) {
    return new Promise((resolve, reject) => {
      calls.deliveries.post(data)
        .then(resp => {
          commit("insertDelivery", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateDelivery: ({commit}, { deliveryId, data }) => {
    return new Promise((resolve, reject) => {
      calls.delivery.put(deliveryId, data).then(
        resp => {
          commit("insertUpdatedDelivery", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Delivery successfully updated'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  addImages: ({commit}, { deliveryId, data }) => {
    return new Promise((resolve, reject) => {
      calls.delivery.addImage(deliveryId, data).then(
        resp => {
          commit("insertUpdatedDelivery", resp.data);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteDelivery: ({commit}, deliveryId) => {
    return new Promise((resolve, reject) => {
      calls.delivery.delete(deliveryId).then(
        resp => {
          commit("removeDelivery", deliveryId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Delivery successfully deleted'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  addItem: ({commit}, item) => {
    return new Promise((resolve, reject) => {
      calls.deliveryStorages.post(item).then(
        resp => {
          commit("insertDeliveryStorage", resp.data);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setDeliveries(state, data) {
    state.pagination = data.pagination;
    state.deliveries = data.results;
  },
  insertDelivery(state, data) {
    state.deliveries.push(data);
  },
  insertUpdatedDelivery(state, data) {
    state.deliveries.forEach((delivery, i) => {
      if (delivery.id == data.id) {
        state.deliveries.splice(i, 1, data);
      }
    })
  },
  removeDelivery(state, deliveryId) {
    state.deliveries.forEach((delivery, i) => {
      if (delivery.id == deliveryId) {
        state.deliveries.splice(i, 1);
      }
      const index = state.selected.indexOf(deliveryId);
      if (index != -1) {
        state.selected.splice(index, 1);
      }
    })
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  insertDeliveryStorage(state, deliveryStorage) {
    state.deliveries.forEach(delivery => {
      if (delivery.id == deliveryStorage.delivery_id) {
        delivery.delivery_storages.push(deliveryStorage);
      }
    })
  },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}